export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M3 15v2h12v-2zm0-8v2h12V7zm18 6v-2H3v2zm0 8v-2H3v2zM3 5h18V3H3z\"/>"
};